import { colors, typography } from '../../../../styles/theme';

export const officialListScrollSx = {
  maxHeight: 360,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(255,255,255,0.22) transparent',
  '&::-webkit-scrollbar': { width: 6 },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(255,255,255,0.18)',
    borderRadius: 99,
  },
};

export const officialCardSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  px: 2,
  py: 1.5,
  borderBottom: `1px solid ${colors.border}`,
  '&:last-of-type': { borderBottom: 'none' },
  transition: 'background-color 0.15s',
};

export const officialCardClickableSx = {
  ...officialCardSx,
  cursor: 'pointer',
  '&:hover': {
    bgcolor: 'rgba(255,255,255,0.04)',
    '& .official-unit-chevron': { color: colors.textPanelTitle },
  },
  '&:active': { bgcolor: 'rgba(255,255,255,0.07)' },
};

export const officialNumberTileSx = {
  width: 44,
  minWidth: 44,
  height: 40,
  borderRadius: '8px',
  bgcolor: colors.backgroundDark,
  border: `1px solid ${colors.border}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

export const officialNumberTextSx = {
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.semibold,
  fontSize: '12px',
  lineHeight: '14px',
  color: colors.textPanelTitle,
  letterSpacing: '0.02em',
};

export const officialTitleSx = {
  fontSize: '14px',
  fontWeight: typography.fontWeight.semibold,
  color: colors.textPanelTitle,
  fontFamily: typography.fontFamily.primary,
  lineHeight: '19px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const officialMetaSx = {
  mt: 0.25,
  fontSize: '12px',
  fontWeight: typography.fontWeight.regular,
  color: colors.textSecondary,
  fontFamily: typography.fontFamily.primary,
  lineHeight: '16px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const officialSearchFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 40,
    bgcolor: colors.backgroundDark,
    borderRadius: '8px',
    color: colors.textPanelDescription,
    fontSize: '13px',
    fontFamily: typography.fontFamily.primary,
    '& fieldset': { borderColor: colors.border },
    '&:hover fieldset': { borderColor: colors.border },
    '&.Mui-focused fieldset': { borderColor: colors.primary },
  },
  '& .MuiInputBase-input': {
    py: 0,
    height: 40,
    boxSizing: 'border-box',
  },
};
